import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { MemberProvider } from "@/context/MemberContext";
import { Layout } from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import CalendarPage from "@/pages/CalendarPage";
import Chores from "@/pages/Chores";
import Cleaning from "@/pages/Cleaning";
import Meals from "@/pages/Meals";
import Shopping from "@/pages/Shopping";
import Rewards from "@/pages/Rewards";

function Splash() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <img src="/logo.png" alt="BentoLife" className="h-14 w-14 animate-pulse rounded-2xl border border-border" />
        <span className="font-display text-lg text-muted-foreground">BentoLife</span>
      </div>
    </div>
  );
}

function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return <Splash />;
  if (!user) return <Navigate to="/landing" replace />;
  return (
    <MemberProvider>
      <Outlet />
    </MemberProvider>
  );
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Splash />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/landing" element={<PublicOnly><Landing /></PublicOnly>} />
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route element={<RequireAuth />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/chores" element={<Chores />} />
              <Route path="/cleaning" element={<Cleaning />} />
              <Route path="/meals" element={<Meals />} />
              <Route path="/shopping" element={<Shopping />} />
              <Route path="/rewards" element={<Rewards />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
